import { inject, provideEnvironmentInitializer } from '@angular/core';
import { InitService } from '@infodata-group/inf-commons';
import { DeviceDetectorService } from '@monorepo-projects/inf-commons-lib';
import { environment } from '../../environments/environment';

const RESET_PASSWORD_PATH = 'reset-password';

const appInitFactory = () => {
  const initService = inject(InitService);
  const deviceService = inject(DeviceDetectorService);

  initService.init(environment.env);
  if (!deviceService.isDesktopDevice()) {
    const currentUrl = window.location.href;
    if (currentUrl.includes(RESET_PASSWORD_PATH)) {
      const splitUrl = currentUrl.split(RESET_PASSWORD_PATH);
      window.location.href =
        environment.mobileUrl + RESET_PASSWORD_PATH + splitUrl[1];
    } else if (currentUrl.includes('consult')) {
      const splitUrl = currentUrl.split('/');
      window.location.href =
        environment.mobileUrl +
        '/planning?consult=' +
        splitUrl[splitUrl.length - 2];
    } else {
      window.location.href = environment.mobileUrl;
    }
  }
};

export const initProvider = provideEnvironmentInitializer(appInitFactory);
